import { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const Lightbox = ({ images, currentIndex, onClose, onPrev, onNext }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'auto';
    };
  }, [onClose, onPrev, onNext]);

  if (currentIndex === null || currentIndex === undefined) return null;

  const currentImage = images[currentIndex];

  return (
    <div 
      className="lightbox-overlay animate-fade-in" 
      onClick={onClose}
      data-testid="lightbox"
    >
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 p-2 bg-white/10 hover:bg-white/20 transition-colors z-10"
        onClick={onClose}
        aria-label="Fermer"
        data-testid="lightbox-close"
      >
        <X size={28} color="white" />
      </button>

      {/* Previous Button */}
      {currentIndex > 0 && (
        <button
          className="absolute left-4 top-1/2 -translate-y-1/2 p-3 bg-white/10 hover:bg-[#F5C500] hover:text-[#1a1a1a] transition-colors"
          onClick={(e) => { e.stopPropagation(); onPrev(); }}
          aria-label="Image précédente"
          data-testid="lightbox-prev"
        >
          <ChevronLeft size={32} />
        </button>
      )}

      {/* Next Button */}
      {currentIndex < images.length - 1 && (
        <button
          className="absolute right-4 top-1/2 -translate-y-1/2 p-3 bg-white/10 hover:bg-[#F5C500] hover:text-[#1a1a1a] transition-colors"
          onClick={(e) => { e.stopPropagation(); onNext(); }}
          aria-label="Image suivante"
          data-testid="lightbox-next"
        >
          <ChevronRight size={32} />
        </button>
      )}

      {/* Image */}
      <div className="relative" onClick={(e) => e.stopPropagation()}>
        <img
          src={currentImage.src}
          alt={currentImage.alt || 'Image galerie'}
          className="max-w-[90vw] max-h-[85vh] object-contain"
          data-testid="lightbox-image"
        />
        {currentImage.caption && (
          <div className="absolute bottom-0 left-0 right-0 bg-black/80 p-4 text-white text-center">
            <p style={{ fontFamily: 'Barlow, sans-serif' }}>{currentImage.caption}</p>
          </div>
        )}
      </div>

      {/* Counter */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/80 text-sm">
        {currentIndex + 1} / {images.length}
      </div>
    </div>
  );
};

export default Lightbox;
